module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Light-f9b1f9228b2877896bd886bb4e2d7e5a.woff";